import React, { useCallback, useEffect, useState } from 'react'

interface Props {
  xs?: React.ReactElement | null
  sm?: React.ReactElement | null
  md?: React.ReactElement | null
  lg?: React.ReactElement | null
  xl?: React.ReactElement | null
}

type ScreenSize = 'xs' | 'sm' | 'md' | 'lg' | 'xl'
const sizes: Array<ScreenSize> = ['xs', 'sm', 'md', 'lg', 'xl']

const Responsive: React.FC<Props & { default?: ScreenSize }> = (props) => {

  const findScreenSize = useCallback(() => {
    const width = document.body.clientWidth
    for (let key in screenSizes) {
      if (width > screenSizes[key][0] && width <= screenSizes[key][1]) {
        return screenSizes[key][2]
      }
    }
  }, [])

  const onResize = useCallback(() => {
    setSize(findScreenSize())
  }, [])

  const [size, setSize] = useState<ScreenSize | undefined>(process.browser ? findScreenSize() : 'md')

  useEffect(() => {
    onResize()
  }, [])

  const screenSizes: Array<[number, number, ScreenSize]> = [
    [0, 576, 'xs'],
    [577, 768, 'sm'],
    [769, 992, 'md'],
    [993, 1200, 'lg'],
    [1201, 100000, 'xl'],
  ]

  useEffect(() => {
    window.addEventListener('resize', onResize)
    return () => window.removeEventListener('resize', onResize)
  }, [])

  const getComponent = (_size?: ScreenSize) => {

    if (!_size) return null;

    if (props[_size]) {
      return props[_size]
    }

    const prevSize = sizes[sizes.findIndex(item => item === _size) - 1]
    if (prevSize) {
      return getComponent(prevSize)
    }
    return null
  }

  return getComponent(size)
}

export default Responsive